
import { RightOutlined } from "@ant-design/icons";
import {Row, Col, Button, Form, Input, Space,DatePicker} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import tournamentService from "../../../api/tournament.service";

import { DATE_FORMAT_DMY_SLASH, EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";

import CustomMessage from "../../common/CustomMessage";
import { addTournament } from "../../../store/tournamentSlice";
import commonUtility from "../../../utility/Utils";
import moment from 'moment';




const TournamentEntry = ({ data , onDrawerClose}) => {

    const dispatch = useDispatch();

    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");   
       
    const [formDefaultValues, setFormDefaultValues] = useState({
        tournament_id: data.tournament_id,
        tournament_name: data.tournament_name,
        venue: data.venue,
        tournament_start_date: data.tournament_start_date,      
        tournament_end_date: data.tournament_end_date,      
        mode: data.mode      
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();

    const onDateChange = (date, dateString) => {
        form.setFieldsValue({
            tournament_start_date: dateString           
        });
    };

    const onEndDateChange = (date, dateString) => {
        form.setFieldsValue({
            tournament_end_date: dateString           
        });
    };



    const onTournamentSave = async (values) => {
        console.log("Tounament", values);
        const data = { formdata: values };

        const response = tournamentService.save(data).then((resdata) => {

            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                tournament_id:commonUtility.randomID(),
                tournament_name:values.tournament_name,
                venue:values.venue,
                tournament_start_date: values.tournament_start_date,
                tournament_end_date: values.tournament_end_date,                
            }
            dispatch(addTournament(x))
        });
    };


    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode=="ADD") {
            form.resetFields();
            form.setFieldsValue({
                tournament_id: formDefaultValues.tournament_id,
                mode: formDefaultValues.mode,                
            })
        }
    }
    

    useEffect(() => {

        mode == EDIT_MODE ?
            form.setFieldsValue({
                tournament_id: formDefaultValues.tournament_id,
                tournament_name: formDefaultValues.tournament_name,
                venue: formDefaultValues.venue,
                tournament_start_picker: formDefaultValues.tournament_start_date != null && formDefaultValues.tournament_start_date != "" ? moment(formDefaultValues.tournament_start_date, DATE_FORMAT_DMY_SLASH) : '',
                tournament_start_date: formDefaultValues.tournament_start_date,  
                tournament_end_picker: formDefaultValues.tournament_end_date != null && formDefaultValues.tournament_end_date != "" ? moment(formDefaultValues.tournament_end_date, DATE_FORMAT_DMY_SLASH) : '',    
                tournament_end_date: formDefaultValues.tournament_end_date              
            })
            :
            form.setFieldsValue({
                tournament_id: 0,
                tournament_name:'',
                venue:'',
                tournament_start_date: '',
                tournament_end_date: '',              
                mode: data.mode               
            });

        form.setFieldsValue(formDefaultValues)
       

    }, [form]);


     

    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onTournamentSave}
                            autoComplete="off"
                           // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>

                            <Form.Item name="tournament_id" label="tournament_id" hidden={true}>
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item name="mode" label="mode" hidden={true}>
                                <Input type="text" />
                            </Form.Item>

                               <Col xs={24} xl={24}>
                                    <Form.Item name="tournament_name" label="Tournament Name" rules={[
                                        {
                                            required: true,
                                            message: 'Tournament name is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={24}>
                                    <Form.Item name="venue" label="Venue" >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={6}>
                                    <Form.Item name="tournament_start_picker" label="Start Date" rules={[
                                        {
                                            required: true,
                                            message: 'Start date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            onChange={onDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="tournament_start_date" label="tournament_start_date" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={6}>
                                    <Form.Item name="tournament_end_picker" label="End Date" rules={[
                                        {
                                            required: true,
                                            message: 'End date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            onChange={onEndDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="tournament_end_date" label="tournament_end_date" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                                 
                                <Col xs={24} xl={22}>
                                    <Form.Item name="" label=" " style={{ textAlign: 'right' }}>
                                        <Space>
                                            <Button htmlType="submit"  className="custom-button-green" >
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>

                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
};

export default TournamentEntry
